export const toBase64 = (file: File) => new Promise((resolve: (result: string) => void, reject: (error: ProgressEvent) => void) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result ? reader.result.toString() : "");
  reader.onerror = error => reject(error);
});
